import API from '@/api/Residential'
import { i18n } from '@/i18n'

let abortController

export default Validator => {
  Validator.registerAsync('residentialNumber', function (number, attribute, req, passes) {
    let [project, initialNumber, draft] = attribute.split(',')

    if (abortController) abortController.abort()
    abortController = new AbortController()

    if (!number || number == initialNumber) return passes()

    const pass = (...args) => {
      if (signal.aborted) return
      passes(...args)
    }

    const signal = abortController.signal
    API.validateNumber({ number, project }, { draft, signal })
      .then(() => pass())
      .catch(() => pass(false, i18n.t('isTaken', { x: i18n.t('unitNumber') })))
  })
}
